import {commonService} from "./common.services";
export  const userService = {
    getAllUsers,
    createUser,
    checkExistingUser,
    getUser,
    updateProfile
}

function getAllUsers(data) {

    return commonService.sendHttpRequest('rbuilder/listusers', data, "GET");
}
function createUser(data) {
    return commonService.sendHttpRequest('rbuilder/saveuser', data, "POST");
}
function getUser(data) {
    return commonService.sendHttpRequest('rbuilder/userprofile', data, "GET");
}
function checkExistingUser(data) {
    return commonService.sendHttpRequest('rbuilder/existinguser', data, "POST");
}
function updateProfile(data) {
    return commonService.sendHttpRequest('rbuilder/saveuserprofile', data, "POST");
}


// WEBPACK FOOTER //
// ./src/services/user.services.js